/**
 @since: 2020-04-06
 @author: tams_dev1
 */
import resultFactory from '~/utils/resultFactory'

export const state = () => ({
  url: '/api/po/qos/profiles',
  qosQueue: {
    qos_class_id: 1, // (integer)(not null) 큐 ID,
    parent_qos_class_id: 1, // (integer)(not null) 부모 큐 ID,
    parent_qos_class_name: '', //  부모 큐 이름
    qos_class_name: '', // (string)(range=1-32) 큐 이름(default 큐가 아닐 경우 사용됨)
    qos_class_prio: 4, // (integer)(Define=0,1,2,3,4,5,6,7) 우선 순위(default 큐가 아닐 경우 사용됨) 우선순위 없음,
    // 그룹큐 : 0 가장 낮음 : 1 매우 낮음 : 2 낮음 : 3 보통 : 4 높음 : 5 매우 높음 : 6 가장 높음 : 7,
    qos_class_rate: 100000000, // (integer) 보장 대역폭 수동 설정(default 큐일 때 사용됨) OFF: 0, ON: 1,
    qos_class_ceil: 100000000, // (integer)(not null)(range=8-100000000) 송신 제한 대역폭(Kbps),
    qos_class_desc: '', // (string)(range=0-128) 큐 설명(default 큐가 아닐 경우 사용됨),
    set_rate: 2, // (integer) 보장 대역폭 수동 설정(default 큐일 때 사용됨) OFF: 0, ON: 1,
    cfg_adm_id: 1,
    admin_login_uname: '',
    cfg_dt: ''
  },
  selQueue: {},
  qosQueueList: [],
  qosQueueCreateBandWidth: {
    qos_class_max_ceil: 100000000,
    qos_class_max_rate: 100000000,
    qos_class_min_ceil: 0,
    qos_class_min_rate: 0
  },
  qosQueueUpdateBandWidth: {
    qos_class_max_ceil: 100000000,
    qos_class_max_rate: 100000000,
    qos_class_min_ceil: 0,
    qos_class_min_rate: 0
  },
  qosParentQueueList: []
})

export const mutations = {
  initQoSQueue (state) {
    state.qosQueueList = []
    state.selQueue = {}
    state.selQueueCheck = false
    state.qosParentQueueList = []
  },
  getQoSQueueList (state, data) { // Queue 조회
    state.qosQueueList = Object.freeze(data)
  },
  getQoSParentQueueList (state, data) {
    const temp = []
    data.forEach(item => {
      temp.push({label: item.qos_class_name, value: item.qos_class_id})
    })
    state.qosParentQueueList = Object.freeze(temp)
  },
  getQoSQueue (state, data) {
    state.qosQueue = _.cloneDeep(data)
  },
  getQoSQueueCreateBandWidth (state, data) {
    state.qosQueueCreateBandWidth = _.cloneDeep(data)
  },
  getQoSQueueUpdateBandWidth (state, data) {
    state.qosQueueUpdateBandWidth = _.cloneDeep(data)
  },
  addQoSQueue (state, data) {
    const cloneQoSQueueList = _.cloneDeep(state.qosQueueList)
    cloneQoSQueueList.push(data)
    state.qosQueueList = Object.freeze(cloneQoSQueueList)
    // 그룹추가시, 상위 그룹선택 목록에 추가한다.
    if (data.qos_class_prio === 0) { // 추가한 큐가 그룹이면,
      const cloneQosParentQueueList = _.cloneDeep(state.qosParentQueueList)
      cloneQosParentQueueList.push({value: data.qos_class_id, label: data.qos_class_name})
      state.qosParentQueueList = Object.freeze(cloneQosParentQueueList)
    }
  },
  editQoSQueue (state, data) {
    state.qosQueueList = Object.freeze(_.map(state.qosQueueList, (item) => {
      if (item.qos_class_id === data.qos_class_id) {
        item = _.cloneDeep(data)
      }
      return item
    }))
  },
  delQoSQueue (state, data) {
    const cloneQosQueueList = _.cloneDeep(state.qosQueueList)
    const itemIndex = _.findIndex(cloneQosQueueList, {qos_class_id: data})
    cloneQosQueueList.splice(itemIndex, 1)
    state.qosQueueList = Object.freeze(cloneQosQueueList)
  },
  setSelQueue (state, data) {
    state.selQueue = _.cloneDeep(data)
  }
}

export const actions = {
  async getQoSQueueList ({commit, state}, {pk, loadingShow = true, loadingHide = true}) {
    const uri = `${state.url}/${pk}/queues`
    try {
      const data = await this.$axios.$get(uri, {loadingShow: loadingShow, loadingHide: loadingHide})
      return resultFactory(commit, {length: null, data: data, action: 'getQoSQueueList', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // Queue 추가/편집 팝업 시 조회
  async getQoSParentQueueList ({commit, state}, {ppk, loadingShow = true, loadingHide = true}) {
    const uri = `${state.url}/${ppk}/parent/queues`
    try {
      const data = await this.$axios.$get(uri, {loadingShow: loadingShow, loadingHide: loadingHide})
      return resultFactory(commit, {length: null, data: data, action: 'getQoSParentQueueList', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // Queue 편집 팝업 시 조회
  async getQoSQueue ({commit, state}, {ppk, pk, loadingShow = true, loadingHide = true}) {
    const uri = `${state.url}/${ppk}/queues/${pk}`
    try {
      const data = await this.$axios.$get(uri, {loadingShow: loadingShow, loadingHide: loadingHide})
      return resultFactory(commit, {length: null, data: data, action: 'getQoSQueue', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // Queue 추가 팝업 시 조회
  async getQoSQueueCreateBandWidth ({commit, state}, {ppk, pk, loadingShow = true, loadingHide = true}) {
    const uri = `${state.url}/${ppk}/queues/${pk}/create/bandwidth`
    try {
      const data = await this.$axios.$get(uri, {loadingShow: loadingShow, loadingHide: loadingHide})
      return resultFactory(commit, {length: null, data: data, action: 'getQoSQueueCreateBandWidth', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 프로파일/Queue 편집 팝업 시 조회
  async getQoSQueueUpdateBandWidth ({commit, state}, {ppk, pk, loadingShow = true, loadingHide = true}) {
    const uri = `${state.url}/${ppk}/queues/${pk}/update/bandwidth`
    try {
      const data = await this.$axios.$get(uri, {loadingShow: loadingShow, loadingHide: loadingHide})
      return resultFactory(commit, {length: null, data: data, action: 'getQoSQueueUpdateBandWidth', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // Queue 추가
  async addQoSQueue ({ commit, state, dispatch }, {ppk, loadingShow = true, loadingHide = true, successAlert = true}) {
    const uri = `${state.url}/${ppk}/queues`
    const payload = {
      parent_qos_class_id: state.qosQueue.parent_qos_class_id,
      qos_class_name: state.qosQueue.qos_class_name,
      qos_class_prio: state.qosQueue.qos_class_prio,
      qos_class_rate: state.qosQueue.qos_class_rate,
      qos_class_ceil: state.qosQueue.qos_class_ceil,
      qos_class_desc: state.qosQueue.qos_class_desc
    }
    try {
      const data = await this.$axios.$post(uri, payload, {loadingShow: loadingShow, loadingHide: loadingHide, successAlert: successAlert})
      return resultFactory(commit, {length: null, data: data, action: 'addQoSQueue', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // Queue 수정
  async editQoSQueue ({ commit, state, dispatch }, {ppk, pk, loadingShow = true, loadingHide = true, successAlert = true}) {
    const uri = `${state.url}/${ppk}/queues/${pk}`
    const editData = {}
    if (state.selQueue.qos_class_id === 2) {
      editData.set_rate = state.qosQueue.set_rate
      editData.qos_class_rate = state.qosQueue.qos_class_rate
      editData.qos_class_ceil = state.qosQueue.qos_class_ceil
    } else {
      editData.qos_class_name = state.qosQueue.qos_class_name
      editData.qos_class_prio = state.qosQueue.qos_class_prio
      editData.qos_class_rate = state.qosQueue.qos_class_rate
      editData.qos_class_ceil = state.qosQueue.qos_class_ceil
      editData.qos_class_desc = state.qosQueue.qos_class_desc
    }
    try {
      const data = await this.$axios.$put(uri, editData, {loadingShow: loadingShow, loadingHide: loadingHide, successAlert: successAlert})
      return resultFactory(commit, {length: null, data: data, action: 'editQoSQueue', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // Queue 삭제
  async delQoSQueue ({ commit, state, dispatch }, {ppk, pk, loadingShow = true, loadingHide = true, successAlert = true}) {
    const uri = `${state.url}/${ppk}/queues/${pk}`
    try {
      const data = await this.$axios.$delete(uri, {loadingShow: loadingShow, loadingHide: loadingHide, successAlert: successAlert})
      return resultFactory(commit, {length: null, data: data, action: 'delQoSQueue', param: pk})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  }
}
